import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { Category, DashboardSummary, UserDashboard } from '../app.models';
import { AppService } from '../app.service';
import { ContentService } from '../services/content.service';
// import * as $ from 'jquery';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import $ from 'jquery';
import { SafeHtmlPipe } from '../templates/safe.pipe';

//==Learn Main Page==//
@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RouterLink, CommonModule, SafeHtmlPipe],
})
export class LearnComponent implements OnInit {
  isLearnDataLoaded: boolean = false;
  categories: Category[];
  userDashboard = new UserDashboard();
  firstName: string = '';
  lastName: string = '';
  emailAddress: string = '';
  mbtiType: string = '';
  tagLine: string = '';
  strengths: string = '';
  totalTopics: string = '';
  totalCompletedTopics: string = '';
  totTopics: number = 0;
  totCompletedTopics: number = 0;
  percentageCompleted: number = 0;
  forwardTarget: string = '';
  swooshText: string = '';
  swooshExternal: string = '';
  Http: HttpClient;
  HttpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  dashboardInitializeSubscription: Subscription;

  constructor(
    private appService: AppService,
    http: HttpClient,
    private contentService: ContentService,
  ) {
    this.Http = http;
  }

  ngOnInit() {
    this.isLearnDataLoaded = false;

    this.appService.getDashboard().subscribe(
      () => {
        this.mbtiType = this.appService.mbtiType;
        this.categories = this.appService.getCategories();
        this.totalTopics = this.appService.getTotalTopics().toString();
        this.totalCompletedTopics = this.appService.getTotalCompletedTopics().toString();
        this.percentageCompleted = (this.appService.getTotalCompletedTopics() / this.appService.getTotalTopics()) * 100;

        var categoryIds = [];
        var isStarted = false;
        this.categories.forEach((item) => {
          categoryIds.push(item.categoryId);
          item.courses.forEach((course) => {
            isStarted = isStarted || course.isStarted;
          });
        });

        if (!isStarted) {
          //Insert into user topics if no record exists or first time user for this course
          var param = {
            SelectedModules: [], // Change this to categoryIds if you want to add specific categories into the Azure table (favorites)
            Courses: this.appService.getUserDashboard().userCourses,
          };
          this.Http.post('/api/user/usercourses', param, this.HttpOptions).subscribe(
            () => {},
            (error) => {
              this.appService.handleError(error);
            },
          );
        }

        if (!this.isShowingEmptyState()) {
          let per = parseInt(this.percentageCompleted.toString(), 10);

          this.contentService.getDashboardSummary<DashboardSummary>(this.mbtiType).subscribe(
            (result) => {
              this.tagLine = result.tagLine;
              this.strengths = result.strengths;

              $('.course-progress-bar').each(function () {
                let bar = $(this).find('.bar');

                $({ p: 0 })
                  .animate(
                    { p: per },
                    {
                      duration: 3000,
                      step: function (p) {
                        bar.css({
                          transform: 'rotate(' + (45 + p * 1.8) + 'deg)',
                        });
                      },
                    },
                  )
                  .delay(200);
              });

              this.isLearnDataLoaded = true;
            },
            (error) => {
              this.appService.handleError(error);
              this.isLearnDataLoaded = true;
            },
          );
        } else {
          this.isLearnDataLoaded = true;
        }

        //get user record
        this.userDashboard = this.appService.getUserDashboard();

        if (this.appService.getTeamInfo().isElevateTeam) {
          this.swooshText = 'Back to Your Elevate Dashboard';
          this.swooshExternal = this.appService.getTeamInfo().redirectUrl;
        }
      },
      (error) => {
        this.appService.handleError(error);
      },
    );
  }

  isShowingEmptyState() {
    return this.appService.isShowingEmptyState();
  }

  unlock() {
    window.location.href = this.appService.assessmentSiteBaseUrl + '/Account/Logon';
  }
}
